require('./expensesByCategoryTabSelector.scss');

// @vendors
import React from 'react';
import PropTypes from 'prop-types';
const { FormattedText } = require('core/i18n').i18n;

// @components
import OKTooltip from 'components/commons/OKTooltip/OKTooltip';
import OKCarousel from 'components/commons/OKCarousel/OKCarousel';
import CategoryTab from './categoryTab/categoryTab'

// @images
import openTutorialImg from 'assets/images/icon-tutorial.svg';

// @utilities
import { getCategoryIconURL } from 'utilities/expensesByCategories/categoriesUtilities';

class ExpensesByCategoryTabSelector extends React.Component {
    constructor(props) {
        super(props);
    }

    getSliderSettings = (categoryTabsData, selectedCategoryId) => {
        const TABS_PER_SLIDE = 5;
        return {
            className: 'expenses-by-category-tabs__carousel',
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: TABS_PER_SLIDE,
            slidesToScroll: TABS_PER_SLIDE,
            draggable: false,
            arrows: false,
            initialSlide: this.getIndexCurrentSlide(categoryTabsData, selectedCategoryId, TABS_PER_SLIDE)
        };
    }

    getIndexCurrentSlide = (tabDataList, selectedCategoryId, tabsPerslide) => {
        const tabIndex = tabDataList.findIndex(tabData => tabData.categoryCode === selectedCategoryId)
        return tabIndex === -1 || tabIndex < tabsPerslide ? 0 : tabIndex;
    }

    handleChangeCategory = (value) => this.props.changeCategoryFilter(value)

    buildCategoryTabs = (tabDataList, selectedCategoryId, totalAmount) => tabDataList ?
        (tabDataList.map((dataTab, index) => (
            <div key={index}>
                <CategoryTab
                    title={dataTab.categoryName}
                    code={dataTab.categoryCode}
                    iconUrl={getCategoryIconURL(dataTab.categoryName)}
                    amount={dataTab.amount}
                    totalAmount={totalAmount}
                    isSelected={selectedCategoryId === dataTab.categoryCode}
                    onClick={this.handleChangeCategory}
                />
            </div>
        ))) : null

    render() {
        const { tabDataList, selectedCategoryId, totalAmount } = this.props;
        const tooltipTarget = (
            <img
                src={openTutorialImg}
                className="expenses-by-category-tab-selector__tooltip-element"
            />
        );

        return (
            <section className="col-xs-12">
                <div className="expenses-by-category-tab-selector">
                    <h3>
                        <FormattedText value="accountMovements-movementsTitle" />
                        <OKTooltip
                            content="globalPositionExpenses-expensesByCategoryTooltip"
                            offset={[15, 0]}
                            placement="right"
                            target={tooltipTarget}
                        />
                    </h3>
                    <div className="expenses-by-category-tab-selector__slider">
                        <OKCarousel
                            numberSlides={tabDataList.length}
                            settings={this.getSliderSettings(tabDataList, selectedCategoryId)}
                            blocks={this.buildCategoryTabs(tabDataList, selectedCategoryId, totalAmount)}
                            leftButtonClass="expenses-by-category-tab-selector__slider__left-button"
                            rightButtonClass="expenses-by-category-tab-selector__slider__right-button"
                            leftIcon="icon-breadcrumb"
                            rightIcon="icon-breadcrumb"
                            customInitial
                        />
                    </div>
                </div>
            </section>
        );
    }
}

ExpensesByCategoryTabSelector.propTypes = {
    changeCategoryFilter: PropTypes.func,
    selectedCategoryId: PropTypes.number,
    tabDataList: PropTypes.array,
    totalAmount: PropTypes.number,
};

ExpensesByCategoryTabSelector.defaultProps = {
    tabDataList: [],
    totalAmount: 0,
};

module.exports = ExpensesByCategoryTabSelector
